<template>
  <LangRouterLink :to="{ name: 'home' }">
    <img src="https://assets.boitebeet.com/hotel-ophelia/70/logo.png" alt="" class="navbar__logo" />
  </LangRouterLink>
</template>

<script>
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'HomeLogoLink',
  components: {
    LangRouterLink,
  },
}
</script>
